import { useLocation } from "react-router-dom";
import { isUnifiedRoute } from "@shared/utils";
import { routes } from "./routes";

/**
 * Хук для получения правильных роутов в зависимости от текущего режима
 * Если мы в unified режиме (/u/...), возвращает routes.unified
 * Иначе возвращает обычные routes
 * 
 * @example
 * const routes = useAppRoutes();
 * const url = routes.general.members(projectId);
 * // В обычном режиме: /projects/:projectId/members/
 * // В unified режиме: /u/projects/:projectId/members/
 */
export function useAppRoutes() {
  const location = useLocation();
  const isUnified = isUnifiedRoute(location.pathname);

  return isUnified ? routes.unified : routes;
}

